export default __webpack_public_path__ + "static/media/google-icon.6b3b0c0e.png";